import React, { FC } from 'react';

import * as S from './titledMessage.styles';
import { TitledMessageProps } from './titledMessage.types';

const TitledMessage: FC<TitledMessageProps> = ({
  title,
  titleAligned = 'start',
  maxWidth = 'none',
  children,
}) => {
  return (
    <S.TitledMessageWrapper $maxWidth={maxWidth}>
      <S.Title align={titleAligned}>{title}</S.Title>
      {children}
    </S.TitledMessageWrapper>
  );
};

export { TitledMessage };
